import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@app/context/ModalsContext'

import { AuthSessionContext } from '@context/AuthContext'

import { getDateTimeFormat } from '@ui/v2/Table/cells/DateTime'
import { useTableColumns } from '@ui/v2/Table/hooks/useTableRows'
import { TableViewMoreModal } from '@ui/v2/Table/modals/TableViewMore.modal'

import { DealDto } from '@model/DealDto'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { IAppendableFetchQueryResult, SearchResponseProps } from '../IBReportResultsPage'
import { IBReportsTable } from '../IBReportsTable'
import { IncomeColumn, IncomeColumnCtx, incomeColumns } from './IBIncomeTable.columns'

export type IBIncomeTableSortKeys =
  | 'TradingAccount.Name'
  | 'TradingAccount.Wallet.Client.Name'
  | 'TradedAt'
  | 'CurrencyId'
  | 'TradingAccount.AccountGroupServer.AccountGroup.TradingAccountType.Name'
  | 'InstrumentName'
  | 'Volume'
  | 'Amount'
  | 'SpreadRevenue'
  | 'TradingAccount.Wallet.Client.TickmillCompany.Name'

interface IBIncomeTableProps {
  data: IAppendableFetchQueryResult<DealDto>
  search: SearchResponseProps
}

export const IBIncomeTable: React.FC<IBIncomeTableProps> = (props) => {
  const { data: dealSummary, search } = props

  const { t } = useTranslation()
  const { formatNumber, formatMoney } = useFormatNumber()

  const [auth] = useContext(AuthSessionContext)
  const rawDateFormat = auth?.dateFormatType?.name
  const dateFormat = getDateTimeFormat(rawDateFormat)

  const colsFormatCtx: IncomeColumnCtx = { t, formatNumber, formatMoney, dateFormat }
  const incomeViewMoreModal = useModal(TableViewMoreModal<DealDto>)

  const data = dealSummary.query.data ?? []
  const { renderColumns } = useTableColumns<DealDto, IncomeColumnCtx, IncomeColumn>({
    columns: incomeColumns,
    formatCtx: colsFormatCtx,
    onArrowClick: (_, index) =>
      incomeViewMoreModal.open({
        data,
        initialIndex: index,
        formatCtx: colsFormatCtx,
        columns: incomeColumns,
      }),
  })

  return (
    <IBReportsTable
      tableQuery={dealSummary.query}
      sortOptions={search.sortOptions}
      renderColumns={renderColumns}
    />
  )
}
